var _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRevert(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_494_19054",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_494_19054)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.9251 20.0401C15.9831 20.7499 14.9663 21.2368 13.8746 21.5008C12.7829 21.7649 11.7002 21.8214 10.6265 21.6705C9.55283 21.5196 8.52768 21.1668 7.55104 20.6121C6.57438 20.0574 5.73114 19.3091 5.02131 18.3671L6.21924 17.4644C7.39278 19.0217 8.93069 19.9341 10.833 20.2014C12.7352 20.4688 14.4651 20.0157 16.0224 18.8422C17.5797 17.6686 18.4921 16.1307 18.7594 14.2284C19.0268 12.3261 18.5737 10.5963 17.4001 9.039C16.2266 7.48166 14.6887 6.56932 12.7864 6.30197C10.8841 6.03462 9.15432 6.48772 7.59699 7.66126L7.38503 7.82098L9.60961 8.13362L9.4207 9.63401L4.62113 8.9526L5.30441 4.13957L6.79876 4.37156L6.48232 6.62304L6.69428 6.46332C7.63625 5.75349 8.6531 5.26657 9.74482 5.00257C10.8365 4.73855 11.9192 4.68198 12.9929 4.83286C14.0665 4.98377 15.0917 5.33657 16.0683 5.89128C17.045 6.44598 17.8882 7.19431 18.5981 8.13629C19.3079 9.07827 19.7948 10.0951 20.0588 11.1868C20.3228 12.2785 20.3794 13.3612 20.2285 14.4349C20.0776 15.5086 19.7248 16.5337 19.1701 17.5104C18.6154 18.487 17.8671 19.3303 16.9251 20.0401Z",
    fill: "#00AAFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.3088 17.1428C9.49748 17.1428 8.86085 16.9147 8.39887 16.4583C7.94253 16.002 7.71436 15.3428 7.71436 14.4809V11.1428H8.81296V14.4386C8.81296 15.047 8.94254 15.4893 9.2017 15.7654C9.46649 16.0414 9.83833 16.1794 10.3172 16.1794C10.7961 16.1794 11.1651 16.0414 11.4243 15.7654C11.6834 15.4893 11.813 15.047 11.813 14.4386V11.1428H12.8947V14.4809C12.8947 15.3428 12.6637 16.002 12.2017 16.4583C11.7454 16.9147 11.1144 17.1428 10.3088 17.1428Z",
    fill: "#00AAFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.4333 17.0583V11.1428H15.5319V17.0583H14.4333Z",
    fill: "#00AAFF"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRevert);
export default __webpack_public_path__ + "static/media/revert.001afee3124e7704b5427097d79e752b.svg";
export { ForwardRef as ReactComponent };